import { render, staticRenderFns } from "./PatternFile.vue?vue&type=template&id=47b73c24&scoped=true"
import script from "./PatternFile.vue?vue&type=script&lang=js"
export * from "./PatternFile.vue?vue&type=script&lang=js"
import style0 from "./PatternFile.vue?vue&type=style&index=0&id=47b73c24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b73c24",
  null
  
)

export default component.exports